export default __webpack_public_path__ + "static/media/pauseIcon.82513fba.svg";